import { motion, MotionProps, PanInfo, MotionValue } from "framer-motion";
import React from "react";

/**
 * Type assertion helpers for motion components with children.
 * This is needed due to framer-motion v6 type incompatibility with React 19.
 * 
 * These types ensure that motion components can accept children props
 * without TypeScript errors.
 */

// Extended props for drag functionality
interface DragProps {
  drag?: boolean | "x" | "y";
  dragConstraints?: { left?: number; right?: number; top?: number; bottom?: number };
  dragElastic?: number | boolean;
  onDragEnd?: (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void;
  onWheel?: (event: React.WheelEvent) => void;
  style?: React.CSSProperties & { 
    x?: MotionValue<number>; 
    y?: MotionValue<number>;
    opacity?: MotionValue<number> | number;
  };
}

export const MotionDiv = motion.div as React.FC<
  MotionProps &
    React.HTMLAttributes<HTMLDivElement> & 
    DragProps & { 
      children?: React.ReactNode;
      ref?: React.Ref<HTMLDivElement>;
    }
>;

export const MotionAside = motion.aside as React.ForwardRefExoticComponent<
  MotionProps &
    React.HTMLAttributes<HTMLElement> & { 
      children?: React.ReactNode;
      ref?: React.Ref<HTMLElement>;
    }
>;

export const MotionButton = motion.button as React.ForwardRefExoticComponent<
  MotionProps &
    React.ButtonHTMLAttributes<HTMLButtonElement> & {
      children?: React.ReactNode;
      ref?: React.Ref<HTMLButtonElement>;
    }
>;

export const MotionSpan = motion.span as React.FC<
  MotionProps &
    React.HTMLAttributes<HTMLSpanElement> & { children?: React.ReactNode }
>;
